export type Role = "ADMIN" | "CONTRIBUTOR" | "EDITOR" | "REVIEWER";
export const ROLES: readonly Role[] = ["ADMIN", "CONTRIBUTOR", "EDITOR", "REVIEWER"];

export type Capability =
  | "trip.read"
  | "trip.manage"
  | "trip.lifecycle"
  | "invitation.manage"
  | "media.contribute"
  | "media.read"
  | "revision.upload"
  | "revision.review";

const BY_ROLE: Record<Role, readonly Capability[]> = {
  ADMIN: ["trip.read", "trip.manage", "trip.lifecycle", "invitation.manage", "media.read"],
  CONTRIBUTOR: ["trip.read", "media.contribute", "media.read"],
  EDITOR: ["trip.read", "media.read", "revision.upload"],
  REVIEWER: ["trip.read", "media.read", "revision.review"],
};

/** Capabilities are additive across a member's roles. */
export function capabilitiesOf(roles: readonly string[]): Set<Capability> {
  const out = new Set<Capability>();
  for (const r of roles) for (const c of BY_ROLE[r as Role] ?? []) out.add(c);
  return out;
}

export function can(roles: readonly string[], capability: Capability): boolean {
  return capabilitiesOf(roles).has(capability);
}
